import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {TasksService} from '../../../tasks/tasks.service';


class CustomWebinarModel {
    date: string;
    link: string;
    time: string;
}

@Component({
    selector: 'app-journey-list-template-webinar',
    templateUrl: './list-template-webinar.component.html',
    styleUrls: ['./list-template-webinar.component.scss']
})
export class LearningJourneyListTemplateWebinarComponent implements OnInit {

    task: TasksModel = null;
    details: CustomWebinarModel = null;
    title: string = null;
    description: string = null;

    @Output() doChange: EventEmitter<CustomWebinarModel> = new EventEmitter();

    @Input('data') set setDetails(data) {
        if (!!data) {
            this.task = data;
            this.details = data.details.webinar && data.details.webinar.length > 0 ? data.details.webinar[0] : null;
            this.title = data.title;
            this.description = data.text;
        }
    }

    constructor(private taskService: TasksService) {
    }

    ngOnInit() {
    }

    onClick(e) {
        this.taskService.runTask(this.task);
    }

    /* onChange(event) {
         this.doChange.emit(this.details);
     }*/

}
